// Tiny gated logger for the country/geolocation resolution flow.
// Enable on the server (or both): set NEXT_PUBLIC_DEBUG_GEO=1
// Enable in a browser without redeploying: localStorage.debugGeo = '1'

const ENV_FLAG = process.env.NEXT_PUBLIC_DEBUG_GEO === '1';

const isClientFlagOn = (): boolean => {
    if (typeof window === 'undefined') return false;
    try {
        return window.localStorage.getItem('debugGeo') === '1';
    } catch {
        return false;
    }
};

export const isGeoDebugEnabled = (): boolean => ENV_FLAG || isClientFlagOn();

export const geoDebug = (label: string, payload?: unknown): void => {
    if (!isGeoDebugEnabled()) return;
    if (payload === undefined) {
        // eslint-disable-next-line no-console
        console.log(`[geo] ${label}`);
    } else {
        // eslint-disable-next-line no-console
        console.log(`[geo] ${label}`, payload);
    }
};
